import type { Block, Text } from '@ksa/model'
import { SiteProse, SiteText, hasText } from '../context.tsx'

type Item = { question: Text; answer: Text }
type Props = { heading: Text; items: Item[] }

/**
 * ⚠️ `<details>`/`<summary>` RATHER THAN A CLICK HANDLER, and that is the reason this block can exist
 * at all on a statically published page. There is NO JavaScript on a published site — the accordion
 * is the browser's own disclosure widget, which is keyboard-operable, announced correctly by screen
 * readers, and findable by the browser's own in-page search even while collapsed. A hand-rolled
 * accordion would need a script on every published page and would get all three of those wrong.
 */
export function FaqBlock({ block }: { block: Block }) {
  const p = block.props as unknown as Props
  const items = (p.items ?? []).filter((i) => hasText(i.question))
  const accordion = block.variant === 'accordion'

  return (
    <section className="s-section">
      <div className="s-wrap s-narrow s-stack-lg">
        {hasText(p.heading) && (
          <h2 className="s-h2">
            <SiteText value={p.heading} />
          </h2>
        )}
        <div>
          {items.map((item, i) =>
            accordion ? (
              <details key={i} className="s-faq__item">
                <summary className="s-faq__q">
                  <SiteText value={item.question} />
                </summary>
                <SiteProse value={item.answer} className="s-body" />
              </details>
            ) : (
              <div key={i} className="s-faq__item">
                <p className="s-faq__q">
                  <SiteText value={item.question} />
                </p>
                <SiteProse value={item.answer} className="s-body" />
              </div>
            ),
          )}
        </div>
      </div>
    </section>
  )
}
